import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Ledgerx() {
    return (
        <>
            <Header />
            <div class="ledgerx-div">
                <div class="ledgerx-div-sub">
                <iframe src="https://ledgerx.otmoic.com" title="ledgerx" height="800" class="relative w-full overflow-hidden" allow="fullscreen; clipboard-write; autoplay" ></iframe>
                </div>
            </div>

            <Footer />
        </>
    )
}